import React from 'react';
import { Link } from 'react-router-dom';
import './Catalog.css';

const Catalog = () => {
  return (
    <section id="catalog" className="catalog">
      <div className="container-custom">
        <h2 className="catalog-title">каталог</h2>
        <div className="catalog-buttons">
          <a href="https://gamma.app/docs/-xx8u5cqxccc41h4" className="catalog-btn" target="_blank" rel="noreferrer">
            Каталог в PDF
          </a>
          <Link to="/certificates" className="catalog-btn">
            Сертификаты
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Catalog;
